import {NgModule} from '@angular/core';
import {WhyFinzySectionComponent} from './why-finzy/why-finzy-section.component';
import {EligibilityCriteriaSectionComponent} from './eligibility-criteria/eligibility-criteria-section.component';
import {HowItWorksSectionComponent} from './how-it-works/how-it-works-section.component';
import {CoreTeamSectionModule} from '../../common/core-team-section/core-team-section.module';
import {CoreTeamSectionComponent} from '../../common/core-team-section/core-team-section.component';
import {BorrowerTestimonialsSectionComponent} from './borrower-testimonials-section/borrower-testimonials-section.component';
import {MatButtonModule} from '@angular/material';

@NgModule({
    declarations: [WhyFinzySectionComponent, EligibilityCriteriaSectionComponent, HowItWorksSectionComponent,
        BorrowerTestimonialsSectionComponent],
    imports: [CoreTeamSectionModule, MatButtonModule],
    exports: [WhyFinzySectionComponent, EligibilityCriteriaSectionComponent, HowItWorksSectionComponent, CoreTeamSectionComponent,
        BorrowerTestimonialsSectionComponent]
})
export class CommonBorrowSectionModule {
}